module.exports = __webpack_public_path__ + "7c56c107c468e4f4deed85ae066f6e27.svg";